import './jquery_1-11-1.js';
window.$ = window.jQuery = $;
// Main entry point for webpack bundling
import './script.js';

// Import other JS files as needed
import './Carousel.js';
import './LightboxGallery.js';
import './product-nav.js';
import './rwdSlider.js';

// Optional: Import constants
import './consts/Events.js';

console.log('Bundle loaded successfully'); 
